// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsListFeature":"vx_a bhb_b","TwoDimsListFeature__item":"vx_b bhb_ux","TwoDimsListFeature__item__text":"vx_c bhb_un"};